export default __webpack_public_path__ + "static/QE-Hover-510dc2d9e441cb82563674912cdc1f1f.svg";